import { createSlice } from "@reduxjs/toolkit";
import { isOnSmallScreen } from "../../utils";
import { FONT_SIZE_MAP } from "../../utils/fontSizeSelection";

const fontSizeLocalStorageName = "customFontSize";

const getInitialFontSize = () => {
  if (typeof window !== "undefined") {
    const stored = localStorage.getItem(fontSizeLocalStorageName);
    if (stored && Object.values(FONT_SIZE_MAP).includes(stored)) {
      return stored;
    }
  }
  return isOnSmallScreen() ? FONT_SIZE_MAP.md : FONT_SIZE_MAP.xs;
};

const initialState = {
  isOpen: false,
  selectedSize: getInitialFontSize(),
  isMobileView: false,
};

const fontSizeAdjustorSlice = createSlice({
  name: "fontSizeAdjustor",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.isOpen = true;
    },
    closeModal: (state, action) => {
      state.isOpen = false;
    },
    setSelectedSize: (state, action) => {
      localStorage.setItem(fontSizeLocalStorageName, action.payload);
      state.selectedSize = action.payload;
    },
    setIsMobileView: (state, action) => {
      state.isMobileView = action.payload;
    },
  },
});

export const { openModal, closeModal, setSelectedSize, setIsMobileView } =
  fontSizeAdjustorSlice.actions;

export default fontSizeAdjustorSlice.reducer;
